export const NOTE_SECTION = {
  hpi: 'HPI',
  ros: 'ROS',
  pe: 'PE',
  ap: 'A/P',
  mdm: 'MDM',
  progress: 'PROGRESS',
  intervalHistory: 'INTERVAL_HISTORY',
  whole_note: 'WHOLE_NOTE',
};
